
import { createGame } from './Mariow';

const node = document.getElementById('app');
createGame(node);



/** WEBPACK FOOTER **
 ** ./index.js
 **/